import * as XLSX from 'xlsx';
import { Token } from '../types';

/**
 * Exports token data to an Excel file
 * @param tokens Array of tokens to export
 * @param marketingColumns Array of marketing column names
 * @param filename Name of the exported file (without extension)
 */
export const exportToExcel = (
  tokens: Token[],
  marketingColumns: string[],
  filename: string = 'marketing-research-data'
): void => {
  // Prepare the data for export
  const exportData = tokens.map(token => {
    // Create a base object with standard fields
    const baseObj: Record<string, string> = {
      'Token Name': token.TokenName,
      'Website Traffic': token.TokenWebsiteTraffic,
      'Total Raised': token.TokenTotalRaised,
      'Telegram': token.Telegram || '',
      'X (Twitter)': token.X || '',
      'Instagram': token.Instagram || ''
    };
    
    // Add marketing columns
    marketingColumns.forEach(column => {
      if (Array.isArray(token[column])) {
        baseObj[column] = (token[column] as string[]).join(', ');
      } else {
        baseObj[column] = '';
      }
    });
    
    return baseObj;
  });
  
  // Create a worksheet
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  
  // Create a workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Tokens');
  
  // Generate Excel file and trigger download
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}; 